import { LinkType } from './link-type.model';


export class Link {
  active: boolean;
  id: number;
  order: number;
  href: string;
  linkType: LinkType;

  constructor (link: any = {}) {
    this.active = link.active || false;
    this.id = link.id || null;
    this.order = link.order || null;
    this.href = link.href || null;
    this.linkType = link.linkType || new LinkType();
  }
}
